import { render, staticRenderFns } from "./allocationDetails.vue?vue&type=template&id=18a4bcc4&scoped=true&"
import script from "./allocationDetails.vue?vue&type=script&lang=js&"
export * from "./allocationDetails.vue?vue&type=script&lang=js&"
import style0 from "./allocationDetails.vue?vue&type=style&index=0&id=18a4bcc4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4bcc4",
  null
  
)

export default component.exports